import { ChiTietTinhThueThang, ThuNhapChiuThueResponse } from "../thue/Thue";

﻿export class ChucVu {
    "id": number;
    "ma": string;
    "ten": string;
    "idBacLuong": number;
    "thuTu": number;
    "isQuanLy": boolean;
}

export class ChucVuResponse {
    "id": number;
    "ma": string;
    "ten": string;
    "idBacLuong": number;
    "tenBacLuong": string;
    "thuTu": number;
    "isQuanLy": boolean;
}

export class ChucVuDang {
    "id": number;
    "ma": string;
    "ten": string;
}

export class ChuyenNganhDaoTao {
    "id": number;
    "ma": string;
    "ten": string;
}

export class ChucVuDoan {
    "id": number;
    "ma": string;
    "ten": string;
}

export class HeSoLuong {
    "id": number;
    "idBacLuong": number;
    "ten": string;
    "heSo": number;
    "mucLuong": number;
    "an"?: boolean;
};

export class HeSoLuongResponse {
    "id": number;
    "idBacLuong": number;
    "tenBacLuong": string;
    "ten": string;
    "heSo": number;
    "mucLuong": number;
    "an"?: boolean;
};

export class BacLuong {
    "id": number;
    "ten": string
    "thuTu": number;
}
export class ChucDanhChuyenMon {
    "id": number;
    "ten": string;
    "ma": string;
}

export class ThongKeTrangChuResponse {
    "tongSoNhanSu": number;
    "tongSoKhoaDaoTao": number;
    "tongSoNhanVienTrinhDo": number;
    "tuoiTacGioiTinhResponse": TuoiTacGioiTinhResponse;
    "thongKeTrinhDoResponse": Array<ThongKeTrinhDoResponse>;
    "thongKeSinhNhat": Array<ThongKeSinhNhat>;
}

export class TuoiTacGioiTinhResponse {
    "duoiBaMuoiNam": number;
    "duoiBaMuoiNu": number;
    "baMuoiBonMuoiNam": number;
    "baMuoiBonMuoiNu": number;
    "bonMuoiNamMuoiNam": number;
    "bonMuoiNamMuoiNu": number;
    "trenNamMuoiNam": number;
    "trenNamMuoiNu": number
}

export class ThongKeTrinhDoResponse {
    "id": number;
    "ten": string;
    "soLuongNhanVien": number
}

export class ThongKeSinhNhat {
    "hoTen": string;
    "tenDonVi": string;
    "tenChucVu": string;
    "avatar": string;
}

export class NhomNhanSu {
    "id": number;
    "ma": string;
    "ten": string;
    "thuTu": number;
}

export class ThuNhapCaNhanChart {
    "kyLuong": string;
    "tongThuNhap": number;
    "thucNhan": number;
    "thang": number;
};

export class ChiTietThuNhap {
    "dsThuNhap": Array<ThuNhapChiuThueResponse>;
    "dsGiamTru": Array<ThuNhapChiuThueResponse>;
    "tongCongGiamTru": number;
    "tongThuNhap": number;
    "thucLinh": number;
}

export class DataChiTietThuNhap {
    "ten": string;
    "value": number;
}

export class LoaiNgayNghi {
    "id": number;
    "ma": string;
    "ten": string;
};

export class CauHinhPhuCapResponse {
    "id": number;
    "tenChucVu": string;
    "tenPhongBan": string;
    "tenPhuCap": string;
    "tienPhuCap": number;
    "idDonVi": number;
    "idChucVu": number;
    "idPhuCap": number;
}
export class ThongBaoLoginResponse {
    "id": number;
    "noiDung": string;
    "trangThai": number;
}

export class QuyetDinh {
    "id": number;
    "ten": string;
    "thuTu": number;
}

export class NhomLyDoNghiViec {
    "id": number;
    "ma": string;
    "ten": string;
    "thuTu": number;
}

export class TrinhDoHVResponse {
    "id": number;
    "ma": string;
    "ten": string;
    "thuTu": number;
}